export default __webpack_public_path__ + "static/media/sealife2.2321345c.jpg";